export const CheckoutSteps = Object.freeze({
  Shipping: 3,
  Payment: 4,
  Confirm: 5, // @TODO: Separate from payment, if possible.
  Success: 5,
})
